// Copyright (c) 2020 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import part from './part';
import partsCoverageSearchStatusChangeModal from './parts-coverage-search-status-change-modal';
import pin from './pin';
import product from './product';
import report from './report';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import warranties from './warranties';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        part,
        partsCoverageSearchStatusChangeModal,
        pin,
        product,
        report,
        showNoResultsFound,
        warranties
    });



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/index.js